var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTooltipOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    role: "img",
    "aria-label": "question",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424A56",
    fillRule: "nonzero",
    d: "M12 5.33a6.67 6.67 0 0 1 6.667 6.667A6.67 6.67 0 0 1 12 18.663a6.67 6.67 0 0 1-6.667-6.666A6.67 6.67 0 0 1 12 5.33zm0 1.333a5.336 5.336 0 0 0-5.333 5.334A5.336 5.336 0 0 0 12 17.33a5.336 5.336 0 0 0 5.333-5.333A5.336 5.336 0 0 0 12 6.663zm0 8a.667.667 0 1 1 0 1.334.667.667 0 0 1 0-1.334zm-2.547-4.78a2.668 2.668 0 0 1 2.954-1.86c1.16.174 2.073 1.154 2.233 2.314.18 1.273-.687 1.766-1.327 2.373-.08.073-.153.147-.22.227-.006.006-.013.02-.02.026-.066.08-.133.167-.186.26-.014.02-.02.04-.034.06-.113.2-.186.434-.186.714h-1.334c0-.334.054-.607.134-.834.006-.02.006-.033.013-.046.007-.02.02-.034.027-.054.046-.12.106-.233.166-.333.007-.013.014-.02.02-.033 0-.007.007-.007.007-.014.553-.833 1.567-1.026 1.633-1.92a1.349 1.349 0 0 0-1.046-1.4 1.335 1.335 0 0 0-1.534.854c-.093.253-.313.446-.586.446h-.134a.605.605 0 0 1-.58-.78z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipOutline);
export default __webpack_public_path__ + "static/media/tooltip-outline.d30c61d10a1ac178483f6af609aed424.svg";
export { ForwardRef as ReactComponent };